import Base from '@/models/base.model.js';
import Professional from './professional.model';
import Lunch from '@/models/lunch.model.js';

export const AVAILABILITY_STATUS = Object.freeze({
	AVAILABLE: 'available',
	OPEN: 'open',
	UNAVAILABLE: 'unavailable',
	PARTIAL: 'partially-confirmed',
});

export const BOOKING_REQUEST_STATUS = Object.freeze({
	OPEN: 'open',
	CANCELLED: 'cancelled',
	REJECTED: 'rejected',
	REQUESTED: 'requested',
	CONFIRMED: 'confirmed',
	PARTIAL_CONFIRMED: 'partially-confirmed',
});

export class Availability extends Base {
	constructor(obj) {
		super(obj);
		if (!obj) return;

		this.date = obj.date;
		this.end_date = obj.end_date;
		this.start_time = obj.start_time;
		this.end_time = obj.end_time;
		this.availability_code = obj.availability_code;
		this.professional = new Professional(obj.professional);
		this.booking_requests = obj.booking_requests;
		this.available_dates = obj.available_dates;
		this.status = obj.status;
		this.isactive = obj.isactive;
		this.isdeleted = obj.isdeleted;
	}

	static get STATUS() {
		return AVAILABILITY_STATUS;
	}
}

export class BookingRequest extends Base {
	constructor(obj) {
		super(obj);
		if (!obj) return;

		this.address = obj.address;
		this.booking_dates = obj.booking_dates;
		this.booking_ref = obj.booking_ref;
		this.contact = obj.contact;
		this.email = obj.email;
		this.end_time = obj.end_time;
		this.id = obj.id;
		this.industry = obj.industry;
		this.lunch = new Lunch(obj.lunch);
		this.name = obj.name;
		this.notes = obj.notes;
		this.rates = obj.rates;
		this.start_time = obj.start_time;
		this.status = obj.status;
		this.status_reason = obj.status_reason;
	}

	static get STATUS() {
		return BOOKING_REQUEST_STATUS;
	}
}

export default Availability;
